import {
  Banner,
  BlockStack,
  Button,
  Card,
  EmptyState,
  Link,
  Page,
} from '@shopify/polaris'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { openChat } from '../../components/ExternalScripts'

function ShopErrorScreen() {
  const { t } = useTranslation()
  return (
    <Page>
      <BlockStack gap={'400'}>
        <Card>
          <EmptyState
            heading={t('ShopErrorScreen.title')}
            footerContent={
              <Button
                variant='plain'
                onClick={() => {
                  window.open('mailto:support@glood.ai', '_blank')
                }}
              >
                {t('ShopErrorScreen.contactCta')}
              </Button>
            }
            image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
          >
            <p>{t('ShopErrorScreen.description')}</p>
          </EmptyState>
        </Card>
      </BlockStack>
    </Page>
  )
}

export default ShopErrorScreen
